<div class="toolbox-add-dialog-container">
  <p class="title">New Query Type</p>
  <form [formGroup]="addItemForm" class="toolbox-form" (ngSubmit)="submit()">
  
    <mat-form-field>
      <mat-label>Query Name</mat-label>
      <textarea
        formControlName="name"
        matInput
        matTextareaAutosize
        matAutosizeMinRows="1"
        placeholder=""></textarea>
    </mat-form-field>
    <arb-message class="message" [message$]="error$"></arb-message>
    <br>
    <div class="buttons">
      <button mat-flat-button color="secondary" type="button" (click)="close(false)">Cancel</button>
      <button mat-flat-button color="primary" type="submit" [disabled]="!addItemForm.valid">Save</button>
    </div>
  </form>
</div>